module.exports = __webpack_public_path__ + "img/NMI_gongjing_2021.f38888d0.jpg";